<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Create Payment Transaction</h3>
    </div>
  </div>
  <div class="form">
    <div class="card-body">
      <div class="form-group row" [formGroup]="form">
        <div class="col-lg-12">
          <mat-form-field appearance="outline" class="mat-form-field-fluid">
            <mat-label>Amount in USD</mat-label>
            <input formControlName="amount" type="tel" matInput />
            <mat-icon matSuffix>attach_money</mat-icon>
            <mat-error *ngIf="amount.invalid">
              {{
                getErrorMessage('amount', 'required') || getErrorMessage('amount', 'patternAmount')
              }}
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="isBank()" appearance="outline" class="mat-form-field-fluid">
            <mat-label>Check Number</mat-label>
            <input [formControl]="checkNumber" type="tel" matInput mask="0000000000000000" />
            <mat-error *ngIf="checkNumber.invalid">
              {{
                getErrorMessage('checkNumber', 'required') ||
                  getErrorMessage('checkNumber', 'pattern')
              }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            color="secondary"
            mat-button
            (click)="onNoClick()"
          >
            Cancel</button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            mat-button
            (click)="onPayClick()"
            color="primary"
            cdkFocusInitial
          >
            Pay
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
